<!--@format-->
<template>
    <div class="recipients-widget">
        <div class="widget-header">
            <h3>Recipients</h3>
            <div class="svg-container widget-close-button" @click="undoChanges">
                <widget-close-svg />
            </div>
        </div>
        <loading-card :is-loading="isLoading" />
        <div v-if="!isLoading" class="content-wrapper">
            <div class="widget-container">
                <document-settings-recipients
                    :form="recipientsForm"
                    :incomplete="isIncomplete"
                    :invalid-emails="invalidEmails"
                    type="document"
                />
            </div>
        </div>
        <div class="widget-footer">
            <div class="actions-container">
                <app-button :loading="isLoading" class="transparent-btn" @click="undoChanges">
                    Cancel
                </app-button>
                <app-button :loading="isLoading" @click="saveRecipients()"> Save </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const DocumentSettingsRecipients = () =>
    import('@/components/sliding-widgets/document/steps/document-settings-recipients.vue');
const LoadingCard = () => import('@/components/common/loading-card');
import EventBus from '@/scripts/event-bus';

export default {
    name: 'recipient-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'loading-card': LoadingCard,
        'document-settings-recipients': DocumentSettingsRecipients,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
            isIncomplete: false,
            invalidEmails: [],
        };
    },

    computed: {
        recipientsForm() {
            return this.widget.options.form;
        },
    },

    watch: {
        recipientsForm: {
            deep: true,
            handler() {
                this.isIncomplete = false;
                this.invalidEmails = [];
            },
        },
    },

    created() {
        EventBus.$emit('document:recipient-widget-open', true);
    },

    beforeDestroy() {
        EventBus.$emit('document:recipient-widget-open', false);
    },	

    methods: {
        validateRecipientsInfo() {
            const value = this.recipientsForm.recipients.every((item) => item.name && item.email);
            this.isIncomplete = !value;
        },

        validateEmails() {
            this.invalidEmails = this.recipientsForm.recipients.filter(
                ({ email }) => !this.$helpers.isValidEmail(email)
            );
        },

        closeWidget() {
            EventBus.$emit('document:recipient-widget-open', false);
            EventBus.$emit('close-widget', this.widget);
        },

        saveRecipients() {
            this.validateRecipientsInfo();
            if (this.isIncomplete) {
                return;
            }

            this.validateEmails();
            if (this.invalidEmails.length) {
                return;
            }
            EventBus.$emit('document:recipients-changes');
            this.closeWidget();
        },

        undoChanges() {
            EventBus.$emit('document:undo-recipients-changes');
            this.closeWidget();
        },
    },
};
</script>

<style>
.recipients-widget.widget .content-wrapper {
    padding: 40px 24px;
}

.recipients-widget .widget-footer .transparent-btn {
    background: transparent;
    border: 1px solid #cac6cb;
    color: #382153;
}

.recipients-widget .widget-footer .transparent-btn:hover {
    background: #e1e0e5;
}

.recipients-widget .widget-footer .actions-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.recipients-widget .widget-footer.existing-template .add-btn {
    padding: 0 40px;
}

.recipients-widget .widget-footer .secondary-btn {
    background: transparent;
    border: 1px solid#18aeff;
    color: #18aeff;
    margin-right: 14px;
}

.recipients-widget .widget-footer .secondary-btn:hover {
    background: #dbedfa;
}

.recipients-widget .widget-footer .secondary-btn span.fa {
    margin-right: 10px;
}

.recipients-widget .widget-footer .app-button:not(.secondary-btn) span.fa {
    margin-left: 10px;
}
</style>
